export default __webpack_public_path__ + "static/media/gallery - story - fountain (1)_02.8e403b69.jpg";